import { Fancybox } from '@fancyapps/ui'
import { $$, on } from '../lib/domUtils'
import { toggleClass } from '../lib/classie'

function specsTableToggle() {
  on($$('.specs-table-wrapper .specs-table-heading'), 'click', e => {
    const specsTableWrapper = e.currentTarget.parentNode
    if (specsTableWrapper) {
      toggleClass(specsTableWrapper, 'is-active')
    }
  })
}

Fancybox.bind('[data-fancybox]', {
  // Your custom options
})

specsTableToggle()
